import axios from 'axios'
import apiUrl from '../_const'

export default {
  getFlavors () {
    return axios.get(apiUrl.FLAVOR_URL, {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/openstack/modules/flavors.js